module.exports = __webpack_public_path__ + "static/media/emptyQuote.da0ff56e.svg";